import { isPlainObject } from '@/utils/isPlainObject';
import { throwIfNotOk } from './responseError';

const CONTENT_TYPE = 'Content-Type';
const CONTENT_TYPE_JSON = 'application/json';

const setHeader = (headers: HeadersInit, name: string, value: string) => {
  if (headers instanceof Headers) {
    headers.set(name, value);
  } else if (Array.isArray(headers)) {
    headers.push([name, value]);
  } else {
    headers[name] = value;
  }
};

export const postRequest = (url: string, data: unknown, init: RequestInit = {}) => {
  init.method = 'POST';

  // default case which sets the content-type and stringifies the data
  if (isPlainObject(data)) {
    if (!init.headers) {
      init.headers = {} as Record<string, string>;
    }

    setHeader(init.headers, CONTENT_TYPE, CONTENT_TYPE_JSON);
    init.body = JSON.stringify(data);
  } else {
    init.body = data as BodyInit;
  }

  return throwIfNotOk(fetch(url, init));
};
